module.exports = __webpack_public_path__ + "img/sv3_1.125fad27.svg";